import React, { useContext } from 'react';
import { injectIntl } from 'react-intl';
import FormContext from "formContext";
import SelectField from "@FormElements/SelectField";
import Tags from '@Components/Tags';

function IndustryPreferencesSelectField({
  intl, settings, ...rest
}) {
  const {formData, currentStep, setFormData, additionalData} = useContext(FormContext);
  const {storeTagsIn} = settings || {};

  const IndustrySectors = additionalData.masterLists && additionalData.masterLists.IndustrySectors;
  if (!IndustrySectors || !Object.keys(IndustrySectors).length) {
    return null;
  }

  const IndustrySectorsOptions = [];
  IndustrySectorsOptions.push({ value: '', label: intl.formatMessage({ id: 'SelectField.EmptyOption.Label' }) });
  IndustrySectors.forEach((industrySector) => {
    IndustrySectorsOptions.push({
      value: industrySector.Code,
      label: industrySector.ListValue,
    });
  });
  settings.options = IndustrySectorsOptions;
  let tagsArray = [];
  if (formData && formData[currentStep] && formData[currentStep][storeTagsIn]) {
    tagsArray = formData[currentStep][storeTagsIn];
  }

  rest.onChange = (e) => {
    const { value } = e.target;
    const match = IndustrySectorsOptions.find((el) => el.value === value);
    let alreadyExisting = false;
    if (formData && formData[currentStep] && formData[currentStep][storeTagsIn]) {
      alreadyExisting = formData[currentStep][storeTagsIn].find((el) => el === match.label);
    }
    if (match && !alreadyExisting) {
      setFormData((prev) => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        if (!prev[currentStep][storeTagsIn]) {
          prev[currentStep][storeTagsIn] = [];
        }
        if (!prev[currentStep].industry_sector_codes) {
          prev[currentStep].industry_sector_codes = [];
        }
        prev[currentStep][storeTagsIn].push(match.label);
        prev[currentStep].industry_sector_codes.push(match.value);
        return {
          ...prev,
        };
      });
    }
  };

  const handleRemove = (key) => {
    setFormData((prev) => {
      prev[currentStep][storeTagsIn].splice(key, 1);
      prev[currentStep].industry_sector_codes.splice(key, 1);
      return {
        ...prev,
      };
    });
  };

  settings.disabled = tagsArray.length >= 3;
  if (settings.errors && settings.errors.hasOwnProperty(storeTagsIn)) {
    settings.errors[settings.name] = settings.errors[storeTagsIn];
  }
  return (
    <>
      <SelectField
        settings={settings}
        {...rest}
      />
      <Tags tags={tagsArray} handleRemove={handleRemove} />
    </>
  );
}
export default injectIntl(IndustryPreferencesSelectField);

